<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Datos de la finca, paisaje y manejo de ganado</h4>
    <form-group :error="errors.has('nombre-finca') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nombreFinca"
      name="nombre-finca"
      required
      v-validate="'required'">
      <label class="form__label">7. Nombre de la finca</label>
    </form-group>

    <form-group :error="errors.has('nombre-propietario')">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nombrePropietario"
      name="nombre-propietario"
      required
      v-validate="'required'">
      <label class="form__label">8. Nombre del propietario de la finca</label>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('telefono-propietario') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.telefonoPropietario"
        name="telefono-propietario"
        required
        v-validate="'required'">
        <label class="form__label">8.1. Teléfono del propietario de la finca</label>
      </form-group>
    </div>

    <form-group>
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nombreCuidador"
      name="nombre-cuidador">
      <label class="form__label">9. Nombre del cuidador o peón</label>
    </form-group>

    <form-group :error="errors.has('nombre-atendedor') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.nombreAtendedor"
      name="nombre-atendedor"
      required
      v-validate="'required'">
      <label class="form__label">10. Nombre de la persona que atendió en la finca</label>
    </form-group>

    <form-group class="identado" :error="errors.has('quien-es') && submitted">
      <label class="form__label form__label--required">10.1. ¿Quién es él?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="quien-es"
        id="propietario"
        v-model="form.body.quienEs"
        value="Propietario"
        v-validate="'required'">
        <label class="form__label" for="propietario">Propietario</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="quien-es"
        id="encargado"
        v-model="form.body.quienEs"
        value="Cuidador/encargado/peón"
        v-validate="'required'">
        <label class="form__label" for="encargado">Cuidador/encargado/peón</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="quien-es"
        id="familiar"
        v-model="form.body.quienEs"
        value="Familiar del propietario"
        v-validate="'required'">
        <label class="form__label" for="familiar">Familiar del propietario</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        name="quien-es"
        id="conocido"
        v-model="form.body.quienEs"
        value="Un vecino/Conocido del propietario"
        v-validate="'required'">
        <label class="form__label" for="conocido">Un vecino/Conocido del propietario</label>
      </div>
    </form-group>

    <form-group>
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.body.telefonoAtendedor"
      name="telefono-atendedor">
      <label class="form__label">11. Teléfono</label>
    </form-group>

    <form-group :error="errors.has('tamano-finca') && submitted">
      <input
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.body.tamanoFinca"
      name="tamano-finca"
      required
      v-validate="'required'">
      <label class="form__label">12. Tamaño total de la finca (hectáreas)</label>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('hectareas-potrero') && submitted">
        <input
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.tamanoPotrero"
        name="hectareas-potrero"
        required
        v-validate="'required'">
        <label class="form__label">12.1. Hectáreas de potrero</label>
      </form-group>

      <div class="form__group">
        <label class="form__label form__label--required">12.2. Hectáreas de bosque</label>
        <p class="text">{{ calcTamanoBosque }}</p>
      </div>
    </div>

    <div>
      <label class="form__label form__label--required">
        13. Ubicación geográfica
      </label>
      <div class="identado">
        <form-group :error="errors.has('provincia') && submitted">
          <select
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.provincia"
          name="provincia"
          required
          v-validate="'required'">
            <option value="" selected="true" disabled="disabled">--Provincia--</option>
            <option :value="key"
            v-for="(value, key) in provincias" :key="key">{{key}}</option>
          </select>
          <label class="form__label">Provincia</label>
        </form-group>
        <form-group :error="errors.has('canton') && submitted">
          <select
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.canton"
          name="canton"
          required
          v-validate="'required'">
            <option value="" selected="true" disabled="disabled">--Canton--</option>
            <option :value="canton"
            v-for="canton in provincias[form.ubicacion.provincia]" :key="canton">{{canton}}</option>
          </select>
          <label class="form__label">Cantón</label>
        </form-group>
        <form-group :error="errors.has('distrito') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.distrito"
          name="distrito"
          required
          v-validate="'required'">
          <label class="form__label">Distrito</label>
        </form-group>
        <form-group :error="errors.has('caseriaPueblo') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.caserio"
          name="caseriaPueblo"
          required
          v-validate="'required'">
          <label class="form__label">Caserío/pueblo</label>
        </form-group>
        <form-group :error="errors.has('direccion') && submitted">
          <textarea
          data-vv-validate-on="blur"
          v-if="editando"
          type="text"
          class="form__input"
          v-model="form.ubicacion.direccion"
          name="direccion"
          required
          v-validate="'required'"/>
          <p v-else class="text">{{form.ubicacion.direccion}}</p>
          <label class="form__label form__label--required">Dirección exacta del lugar</label>
        </form-group>
      </div>
    </div>

    <div class="form__group">
      <label class="form__label form__label--required">
        14. La cantidad de animales en su finca es:
      </label>
      <div class="form__group--inline">
        <label class="form__label">Reses</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.reses">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Caballos</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.caballos">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Cabras</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.cabras">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Ovejas</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.ovejas">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Búfalos</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.bufalos">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Cerdos</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.cerdos">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Aves de corral/granja</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.aves">
      </div>
      <div class="form__group--inline">
        <label class="form__label">Perros</label>
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.cantAnimales.perros">
      </div>
    </div>

    <div class="identado" v-if="form.body.cantAnimales.reses">
      <form-group :error="errors.has('razas-reses') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.razasReses"
        name="razas-reses"
        required
        v-validate="'required'">
        <label class="form__label">15. ¿Qué razas de reses tiene?</label>
      </form-group>
    </div>


    <form-group :error="errors.has('actividad-economica') && submitted">
      <label class="form__label form__label--required">
        16. Principal actividad económica de la finca
      </label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-carne"
        name="actividad-economica"
        v-validate="'required'"
        value="Ganadería/carne">
        <label class="form__label" for="act-eco-carne">Ganadería/carne</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-leche"
        name="actividad-economica"
        v-validate="'required'"
        value="Ganadería/leche">
        <label class="form__label" for="act-eco-leche">Ganadería/leche</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-queso"
        name="actividad-economica"
        v-validate="'required'"
        value="Ganadería/queso">
        <label class="form__label" for="act-eco-queso">Ganadería/queso</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-doble"
        name="actividad-economica"
        v-validate="'required'"
        value="Ganadería/doble propósito">
        <label class="form__label" for="act-eco-doble">Ganadería/doble propósito</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-turismo"
        name="actividad-economica"
        v-validate="'required'"
        value="Turismo">
        <label class="form__label" for="act-eco-turismo">Turismo</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-agricultura"
        name="actividad-economica"
        v-validate="'required'"
        value="Agricultura">
        <label class="form__label" for="act-eco-agricultura">Agricultura</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.actividadEconomica"
        id="act-eco-forestal"
        name="actividad-economica"
        v-validate="'required'"
        value="Forestal">
        <label class="form__label" for="act-eco-forestal">Forestal</label>
      </div>
    </form-group>

    <form-group :error="errors.has('causas-muerte') && submitted">
      <label class="form__label form__label--required">
        17. ¿Cuáles son las 2 principales causas de muerte de sus animales?
      </label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="accidente"
        name="causas-muerte"
        v-validate="'required'"
        value="Accidentes">
        <label class="form__label" for="accidente">Accidentes</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="desnutricion"
        name="causas-muerte"
        v-validate="'required'"
        value="Desnutrición">
        <label class="form__label" for="desnutricion">Desnutrición</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="parasitos"
        name="causas-muerte"
        v-validate="'required'"
        value="Parásitos">
        <label class="form__label" for="parasitos">Parásitos</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="cuatreros"
        name="causas-muerte"
        v-validate="'required'"
        value="Cuatreros">
        <label class="form__label" for="cuatreros">Cuatreros</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="por-partos"
        name="causas-muerte"
        v-validate="'required'"
        value="Por partos">
        <label class="form__label" for="por-partos">Por partos</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="depredacion"
        name="causas-muerte"
        v-validate="'required'"
        value="Depredación">
        <label class="form__label" for="depredacion">Depredación</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="serpientes"
        name="causas-muerte"
        v-validate="'required'"
        value="Serpientes">
        <label class="form__label" for="serpientes">Serpientes</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="enfermedades"
        name="causas-muerte"
        v-validate="'required'"
        value="Enfermedades">
        <label class="form__label" for="enfermedades">Enfermedades</label>
      </div>
      <form-group
      v-if="includes(form.body.causasMuerte, 'Enfermedades')"
      :error="errors.has('nombre-enfermedad') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.causasMuerteEnfermedad"
        name="nombre-enfermedad"
        required
        v-validate="'required'">
        <label class="form__label">Indique enfermedad</label>
      </form-group>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.causasMuerte"
        id="otra-causa"
        name="causas-muerte"
        v-validate="'required'"
        value="Otro">
        <label class="form__label" for="otra-causa">Otro / Comentarios adicionales</label>
      </div>
      <div class="identado">
        <form-group
        v-if="includes(form.body.causasMuerte, 'Otro')"
        :error="errors.has('nombre-otra-causa')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.body.causasMuerteOtro"
          name="nombre-otra-causa"
          required
          v-validate="'required'">
          <label class="form__label">Indique cuál</label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('sistema-manejo') && submitted">
      <label class="form__label form__label--required">
        18. ¿Cuál es el sistema de manejo o explotación de los animales en la finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.sistemaManejoFinca"
        id="estabulado"
        name="sistema-manejo"
        v-validate="'required'"
        value="Estabulado">
        <label class="form__label" for="estabulado">Estabulado</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.sistemaManejoFinca"
        id="semi-estabulado"
        name="sistema-manejo"
        v-validate="'required'"
        value="Semi-estabulado">
        <label class="form__label" for="semi-estabulado">Semi-estabulado</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.sistemaManejoFinca"
        id="extensivo"
        name="sistema-manejo"
        v-validate="'required'"
        value="Extensivo (potreros mayores a 2 has.)">
        <label class="form__label" for="extensivo">Extensivo (potreros mayores a 2 has.)</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.sistemaManejoFinca"
        id="intensivo"
        name="sistema-manejo"
        v-validate="'required'"
        value="Intensivo (pequeños potreros con rotación)">
        <label class="form__label" for="intensivo">Intensivo (pequeños potreros con rotación)
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('entra-ganado-bosque') && submitted">
      <label class="form__label form__label--required">19. ¿Entra el ganado al bosque?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.entraGanadoBosque"
        id="si-entra"
        name="entra-ganado-bosque"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-entra">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.entraGanadoBosque"
        id="no-entra"
        name="entra-ganado-bosque"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-entra">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('ganaderia-unico-ingreso') && submitted">
      <label class="form__label form__label--required">
        20. ¿La ganadería es su único medio de ingreso económico?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.esGanaderiaUnicoIngreso"
        id="si-unico-ingreso"
        name="ganaderia-unico-ingreso"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-unico-ingreso">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.esGanaderiaUnicoIngreso"
        id="no-unico-ingreso"
        name="ganaderia-unico-ingreso"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-unico-ingreso">No</label>
      </div>
    </form-group>

    <div class="identado">
      <form-group
      v-if="form.body.esGanaderiaUnicoIngreso === false"
      :error="errors.has('unico-ingreso-otro') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        class="form__input"
        v-model="form.body.otroIngreso"
        name="unico-ingreso-otro"
        required
        v-validate="'required'">
        <label class="form__label">Indique cuál es la otra actividad</label>
      </form-group>
    </div>

    <form-group :error="errors.has('cant-potreros') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.body.cantPotreros"
      name="cant-potreros"
      required
      v-validate="'required'">
      <label class="form__label">21. Cuántos potreros/apartos en total tiene la finca?</label>
    </form-group>

    <div class="identado">
      <form-group :error="errors.has('tamanoPotreros') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="number"
        class="form__input"
        v-model.number="form.body.tamanoPotreros"
        name="tamanoPotreros"
        required
        v-validate="'required'">
        <label class="form__label">
          21.1. En promedio, el tamaño <strong>en hectáreas</strong> de los potreros es de
        </label>
      </form-group>

      <form-group :error="errors.has('descripcion-potreros') && submitted">
        <label class="form__label form__label--required">
          21.2. En su mayoría, los potreros/apartos son
        </label>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.descripcionPotreros"
          id="planos"
          name="descripcion-potreros"
          v-validate="'required'"
          value="Planos">
          <label class="form__label" for="planos">Planos</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.descripcionPotreros"
          id="pendientes-tenues"
          name="descripcion-potreros"
          v-validate="'required'"
          value="Con pendientes tenues">
          <label class="form__label" for="pendientes-tenues">Con pendientes tenues</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.descripcionPotreros"
          id="pendientes-fuertes"
          name="descripcion-potreros"
          v-validate="'required'"
          value="Con pendientes fuerte">
          <label class="form__label" for="pendientes-fuertes">Con pendientes fuertes</label>
        </div>
      </form-group>
    </div>

    <form-group :error="errors.has('hay-corral') && submitted">
      <label class="form__label form__label--required">
        22. En su finca hay algún corral/encierro
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCorral"
        id="si-hay-corral"
        name="hay-corral"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-corral">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCorral"
        id="no-hay-corral"
        name="hay-corral"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-corral">No</label>
      </div>
    </form-group>

    <form-group class="identado"
    v-if="form.body.hayCorral"
    :error="errors.has('condicion-corral') && submitted">
      <label class="form__label form__label--required">¿En qué condición está?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCorralCondicion"
        id="corral-bueno"
        name="condicion-corral"
        v-validate="'required'"
        value="Bueno">
        <label class="form__label" for="corral-bueno">Bueno</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCorralCondicion"
        id="corral-malo"
        name="condicion-corral"
        v-validate="'required'"
        value="Malo">
        <label class="form__label" for="corral-malo">Malo</label>
      </div>
    </form-group>

    <form-group :error="errors.has('revisan-diario-ganado') && submitted">
      <label class="form__label form__label--required">
        23. ¿Revisan y están en contacto con el ganado todos los días?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiario"
        id="si-revisan-diario"
        name="revisan-diario-ganado"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-revisan-diario">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiario"
        id="no-revisan-diario"
        name="revisan-diario-ganado"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-revisan-diario">No</label>
      </div>
    </form-group>

    <form-group class="identado"
    v-if="form.body.revisionGanadoDiario === false"
    :error="errors.has('dias-revision-ganado') && submitted">
      <label class="form__label form__label--required">¿Cada cuántos días?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="dia-por-medio"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="De día por medio">
        <label class="form__label" for="dia-por-medio">De día por medio</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="cada2dias"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Cada 2 días">
        <label class="form__label" for="cada2dias">Cada 2 días</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="cada3dias"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Cada 3 días">
        <label class="form__label" for="cada3dias">Cada 3 días</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="cada4dias"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Cada 4 días">
        <label class="form__label" for="cada4dias">Cada 4 días</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="cada5dias"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Cada 5 días">
        <label class="form__label" for="cada5dias">Cada 5 días</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="vezxsemana"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Una vez por semana">
        <label class="form__label" for="vezxsemana">Una vez por semana</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.revisionGanadoDiarioFrecuencia"
        id="menos-vezxsemana"
        name="dias-revision-ganado"
        v-validate="'required'"
        value="Menos de una vez por semana">
        <label class="form__label" for="menos-vezxsemana">Menos de una vez por semana</label>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-partos') && submitted">
      <label class="form__label form__label--required">
        24. ¿Se dan nacimientos/partos en su finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayPartos"
        id="si-hay-partos"
        name="hay-partos"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-partos">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayPartos"
        id="no-hay-partos"
        name="hay-partos"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-partos">No</label>
      </div>
    </form-group>

    <div class="identado" v-if="form.body.hayPartos === true">
      <form-group
      :error="errors.has('lugar-partos') && submitted">
        <label class="form__label form__label--required">¿Dónde se dan los nacimientos?</label>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.hayPartosLugar"
          id="potrero-abierto"
          name="lugar-partos"
          v-validate="{ required: !form.body.hayPartosLugarCheckOtro }"
          value="Potreros abierto (donde sea)">
          <label class="form__label" for="potrero-abierto">Potreros abierto (donde sea)</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.hayPartosLugar"
          id="potrero-maternidad"
          name="lugar-partos"
          v-validate="{ required: !form.body.hayPartosLugarCheckOtro }"
          value="Potrero de maternidad">
          <label class="form__label" for="potrero-maternidad">Potrero de maternidad</label>
        </div>
        <div class="radio radio--azul">
          <input
          :disabled="!editando"
          type="radio"
          v-model="form.body.hayPartosLugar"
          id="corral-encierro"
          name="lugar-partos"
          v-validate="{ required: !form.body.hayPartosLugarCheckOtro }"
          value="Corral/encierro">
          <label class="form__label" for="corral-encierro">Corral/encierro</label>
        </div>
        <div class="checkbox checkbox--azul">
          <input
          :disabled="!editando"
          type="checkbox"
          v-model="form.body.hayPartosLugarCheckOtro"
          id="otro-lugar-partos">
          <label class="form__label" for="otro-lugar-partos">Otro / Comentarios adicionales</label>
        </div>
      </form-group>

      <form-group
      v-if="form.body.hayPartosLugarCheckOtro"
      :error="errors.has('nombre-otro-lugar-partos') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.hayPartosLugarOtro"
        name="nombre-otro-lugar-partos"
        required
        v-validate="'required'">
        <label class="form__label">Indique cuál</label>
      </form-group>
    </div>

    <form-group :error="errors.has('asp') && submitted">
      <label class="form__label form__label--required">
        25. ¿La propiedad está dentro de alguna ASP?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.asp"
        id="si-asp"
        name="asp"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-asp">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.asp"
        id="no-asp"
        name="asp"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-asp">No</label>
      </div>
    </form-group>

    <div class="identado" v-if="form.body.asp !== undefined">
      <form-group :error="errors.has('nombre-asp') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.aspNombre"
        name="nombre-asp"
        required
        v-validate="'required'">
        <label class="form__label">
          <span v-if="form.body.asp">¿Cuál ASP?</span>
          <span v-else>¿Cuál es la ASP más cercana a la propiedad?</span>
        </label>
      </form-group>
    </div>

    <form-group :error="errors.has('hay-cercas') && submitted">
      <label class="form__label form__label--required">
        26. ¿Existen cercas/barreras que separen los potreros del bosque?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCercas"
        id="si-hay-cercas"
        name="hay-cercas"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-cercas">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayCercas"
        id="no-hay-cercas"
        name="hay-cercas"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-cercas">No</label>
      </div>
    </form-group>

    <form-group class="identado"
    v-if="form.body.hayCercas"
    :error="errors.has('tipo-cerca') && submitted">
      <label class="form__label form__label--required">¿De qué tipo?</label>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.hayCercasTipo"
        id="cerca-puas"
        name="tipo-cerca"
        v-validate="'required'"
        value="Púas">
        <label class="form__label" for="cerca-puas">Púas</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.hayCercasTipo"
        id="cerca-electrica"
        name="tipo-cerca"
        v-validate="'required'"
        value="Eléctricas">
        <label class="form__label" for="cerca-electrica">Eléctricas</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.hayCercasTipo"
        id="malla-ganadera"
        name="tipo-cerca"
        v-validate="'required'"
        value="Malla ganadera">
        <label class="form__label" for="malla-ganadera">Malla ganadera</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.body.hayCercasTipo"
        id="tipo-cerca-otra"
        name="tipo-cerca"
        v-validate="'required'"
        value="Otro">
        <label class="form__label" for="tipo-cerca-otra">Otro / Comentarios adicionales</label>
      </div>
      <form-group
      v-if="includes(form.body.hayCercasTipo, 'Otro')"
      :error="errors.has('cerca-nombre-otra') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.hayCercasTipoOtro"
        name="cerca-nombre-otra"
        required
        v-validate="'required'">
        <label class="form__label">Indique cuál</label>
      </form-group>
    </form-group>


    <form-group :error="errors.has('hay-area-humedal') && submitted">
      <label class="form__label form__label--required">
        27. ¿Hay áreas de humedal dentro de la finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayAreaHumedal"
        id="si-hay-humedal"
        name="hay-area-humedal"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-humedal">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayAreaHumedal"
        id="no-hay-humedal"
        name="hay-area-humedal"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-humedal">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-quebradas') && submitted">
      <label class="form__label form__label--required">
        28. ¿Hay quebradas o ríos dentro de la finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayQuebradas"
        id="si-hay-quebradas"
        name="hay-quebradas"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-quebradas">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayQuebradas"
        id="no-hay-quebradas"
        name="hay-quebradas"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-quebradas">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-lagos') && submitted">
      <label class="form__label form__label--required">
        29. ¿Hay lagos o lagunas dentro de la finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayLagos"
        id="si-hay-lagos"
        name="hay-lagos"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-lagos">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayLagos"
        id="no-hay-lagos"
        name="hay-lagos"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-lagos">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-electricidad') && submitted">
      <label class="form__label form__label--required">30. Hay electricidad en la finca?</label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayElectricidad"
        id="si-hay-electricidad"
        name="hay-electricidad"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-electricidad">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayElectricidad"
        id="no-hay-electricidad"
        name="hay-electricidad"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-electricidad">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('hay-madera-resistente') && submitted">
      <label class="form__label form__label--required">
        31. Hay disponibilidad de madera resistente en la finca?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayMaderaResistente"
        id="si-hay-madera"
        name="hay-madera-resistente"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="si-hay-madera">Sí</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.body.hayMaderaResistente"
        id="no-hay-madera"
        name="hay-madera-resistente"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="no-hay-madera">No</label>
      </div>
    </form-group>

    <div class="identado">
      <form-group
      v-if="form.body.hayMaderaResistente"
      :error="errors.has('tipo-madera') && submitted">
        <input
        data-vv-validate-on="blur"
        :disabled="!editando"
        type="text"
        class="form__input"
        v-model="form.body.hayMaderaResistenteTipo"
        name="tipo-madera"
        required
        v-validate="'required'">
        <label class="form__label">¿Qué tipos/especies hay?</label>
      </form-group>
    </div>
  </form>
</template>

<script>
import includes from "lodash/includes";
import provincias from "../../comunes/cr-division-politica.json";

export default {
  name: "FormGanadoBloque2",
  data() {
    return {
      provincias,
    };
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
    includes,
  },
  computed: {
    calcTamanoBosque() {
      return (this.form.body.tamanoFinca - this.form.body.tamanoPotrero) || 0;
    },
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
